import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';

@Component({
	selector: 'app-group-offer-price-setting-dialog',
	templateUrl: './group-offer-price-setting-dialog.component.html',
	styleUrls: ['./group-offer-price-setting-dialog.component.css'],
})
export class GroupOfferPriceSettingDialogComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<GroupOfferPriceSettingDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		protected bag: DataBagService,
	) {}

	ngOnInit(): void {
		this.bag.get('/currency/?limit=999', (result, error) => {
			this.currency = result.results;
			// this.changeCurrency();
		});
		this.bag.get('/board/?limit=999', (result, error) => {
			this.board = result.results;
		});
		this.bag.get('/offer/price_option/', (result, error) => {
			this.priceOption = result.results;
			this.priceOption.map((obj) => {
				if (obj.method == 'C') {
					obj.method = 'PLN';
				} else obj.method = '%';
			});
		});
	}

	disableHTMLClose: boolean;
	currency: Array<any> = [];
	board: Array<any> = [];
	priceOption: Array<any> = [];
	priceSetting: Array<any> = [];
	closeDialog() {
		this.dialogRef.close();
	}
}
